import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import BasicButton from '@/ui-components/BasicButton.vue';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useLinearBroadcastTime } from '@/components/experiments/LinearTVExp';


export default /*#__PURE__*/_defineComponent({
  __name: 'LinearOfferCTA',
  props: {
    availableFromTime: null,
    availableToTime: null,
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	availableFromTime: string | undefined;
	availableToTime: string | undefined;
	disabled?: boolean;
};



const { country, language } = storeToRefs(useLanguageStore());
const { v2Date, broadcastTimeZone } = useLinearBroadcastTime();

const time = computed(() => {
	const rawDateStart = new Date(props.availableFromTime as unknown as Date);

	return new Intl.DateTimeFormat(`${language.value.split('-')[0]}-${country.value}`, {
		hour: '2-digit',
		minute: '2-digit',
		timeZone: broadcastTimeZone.value,
		timeZoneName: 'short',
		hourCycle: 'h23',
	}).format(rawDateStart);
});

return { __sfc: true,props, country, language, v2Date, broadcastTimeZone, time, BasicButton }
}

})